import { types } from "mobx-state-tree";
import { AutoscalerModel } from "./autoscaler";
import { TaintModel } from "./common";
import { NetworkingModel } from "./networking";
import { PreInstallScriptProperty } from "./preInstallScript";

const AmiModel = types.model("Ami Model", {
  recommended: types.maybe(types.string), //'ubuntu/noble-24.04', 'ubuntu/jammy-22.04', 'ubuntu/focal-20.04'
  reference: types.maybe(
    types.model({
      publisher: types.string,
      offer: types.string,
      sku: types.string,
      version: types.string,
    }),
  ),
});

const AzureProviderNodePoolModel = types.model("Azure Provider Node Pool", {
  name: types.string,
  labels: types.frozen(),
  taints: types.array(TaintModel),
  size: types.string,
  subnetId: types.string,
  zones: types.array(types.number), // 1 2 3
  minSize: types.number,
  maxSize: types.number,
  overrideImage: types.optional(AmiModel, () => AmiModel.create()),
  bootDiskSize: types.optional(types.number, 20),
});

export const AzureProviderModel = types.model("Azure Provider", {
  location: types.string,
  subscriptionId: types.string,
  sdkSecretLink: types.string,
  resourceGroup: types.string,
  networking: types.optional(NetworkingModel, () => NetworkingModel.create()),
  preInstallScript: PreInstallScriptProperty,
  image: AmiModel,
  sshKeys: types.array(types.string),
  networkId: types.string,
  tags: types.optional(types.frozen(), {}),
  nodePools: types.array(AzureProviderNodePoolModel),
  autoscaler: types.optional(AutoscalerModel, () => AutoscalerModel.create()),
});
